import { Routes } from '@angular/router';

export const routes: Routes = [
      {
        path: '', 
        loadComponent: () => import('./sitemap.component').then(m => m.SitemapComponent),
        data: {
          title: "KudosHub | Sitemap",
          description:"Use our sitemap to navigate to any page on our site quickly.",
          keywords: "email list validation",
          ogTitle: "KudosHub | Sitemap",
          ogDesc:"Use our sitemap to navigate to any page on our site quickly.",
          ogImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
          ogUrl: "https://kudoshub.com/sitemap",
          twitterTitle: "KudosHub | Sitemap",
          twitterDesc:"Use our sitemap to navigate to any page on our site quickly.",
          twitterImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
        },
      }        
];
